<template>
  <div id="app" :class="{loaded: loaded, loading: !loaded}">

    <transition name="preloader-fade">
      <Preloader v-if="!loaded"  />
    </transition>

    <CookieBanner v-if="loaded"  />
    <AppNavigation />

    <router-view role="main" class="router-view" ></router-view>

    <AppFooter />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

import AppNavigation from '@/components/ui/AppNavigation';
import AppFooter from '@/components/ui/AppFooter';
import CookieBanner from '@/components/ui/CookieBanner';
import Preloader from '@/components/ui/Preloader';

export default {
  name: 'app',
  components: {
    AppNavigation,
    AppFooter,
    CookieBanner,
    Preloader
  },
  data() {
    return {
      userLoaded: false,
      postsLoaded: false,
      latestPostsLoaded: false,
      homepageLoaded: false,
      fightersLoaded: false,
      wallpapersLoaded: false,
      screenshotsLoaded: false,
      videosLoaded: false,
    }
  },
  created() {
    this.getUser().then(() => {
      this.userLoaded = true;
    });

    this.getPosts().then((res) => {
      this.postsLoaded = true;
    });

    this.getLatestPosts().then((res) => {
      this.latestPostsLoaded = true;
    });

    this.getHomepage().then((res) => {
      this.homepageLoaded = true;
    });

    this.getFighters().then(() => {
      this.fightersLoaded = true;
    });

    this.getWallpapers().then(() => {
      this.wallpapersLoaded = true;
    });

    this.getScreenshots().then(() => {
      this.screenshotsLoaded = true;
    });

    this.getVideos().then(() => {
      this.videosLoaded = true;
    });
  },
  computed: {
    ...mapGetters({
      latestPosts: 'latestPosts',
      posts: 'posts',
      homepage: 'homepage',
      fighters: 'fighters',
      wallpapers: 'wallpapers',
      screenshots: 'screenshots',
      videos: 'videos'
    }),
    loaded() {
      return this.userLoaded && this.postsLoaded && this.latestPostsLoaded && this.homepageLoaded && this.fightersLoaded && this.wallpapersLoaded && this.screenshotsLoaded && this.videosLoaded;
    }
  },
  methods: {
    ...mapActions({
      getUser: 'getUser',
      getLatestPosts: 'getLatestPosts',
      getPosts: 'getPosts',
      getHomepage: 'getHomepage',
      getFighters: 'getFighters',
      getWallpapers: 'getWallpapers',
      getScreenshots: 'getScreenshots',
      getVideos: 'getVideos'
    })
  }
}
</script>
<style lang="scss">
@import '@/scss/_reset.scss';
@import '@/scss/_fonts.scss';
@import '@/scss/_sections.scss';
// @import '@/scss/_debug.scss';



#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  &.loading {
    height: 100vh;
    overflow: hidden;
    min-height: 0;
  }
}
.router-view {
  flex: 1;
  margin-top: -30px;

  @include bp($bp--xl) {
    margin-top: 0;
  }
}
.container {
  padding: 0 20px;
  width: 100%;
  max-width: $max-width;
  margin: 0 auto;

  &.full-width-small {
    @include bp($bp--s, false) {
      padding: 0;
    }
  }
}

.hover {
  transition: opacity 0.25s ease-in;
  &:hover {
    opacity: 0.7;
  }
}

body.modal-open {
  overflow: hidden;
}

.close-modal {
  display: block;
  width: 40px;
  height: 40px;
  background: transparent url('~@/assets/images/close.png') no-repeat center center;
  position: absolute;
  cursor: pointer;
}

.button-container {
  display: flex;
  justify-content: center;
}

.video-holder {
  width: 100%;
  //background: rgba(#000, 0.5);
  max-width: 1800px;
  @include aspect-ratio(16,9);
  .aspect-content {
    background: transparent;
    transition: background .25s ease-out;
  }
  &.active {
    z-index: 5;

    .aspect-content {
      background: #000;
    }
  }

}
.youtube-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.preloader-fade-enter-active,
.preloader-fade-leave-active {
  transition: opacity 0.5s ease-out 1s;
}

.preloader-fade-enter,
.preloader-fade-leave-to {
  opacity: 0;
}

// Loading states
img[lazy=loading] {
  opacity: 0;
}
img[lazy=error] {
}
img[lazy=loaded] {
  opacity: 1;
}



.flex-1 {
  flex: 1;
}
.flex-column {
  display: flex;
  flex-direction: column;
}

// a:focus, button:focus { outline: #29c0ff solid 2px; }
// button:focus:not(:focus-visible), a:focus:not(:focus-visible) {
//   /* Undo all the above focused button styles
//      if the button has focus but the browser wouldn't normally
//      show default focus styles */
//      outline: none;
// }
// a:focus-visible, button:focus-visible { outline: #29c0ff solid 2px; }

a:focus,
button:focus {
 outline:none;
}

// /* Remove outline for non-keyboard :focus */
// *:focus:not(.focus-visible) {
//   outline: none;
// }

// /* Optional: Customize .focus-visible */
// .focus-visible {
//   outline: lightgreen solid 2px;
// }

/**
 * Language Specifics
 */
html[lang="ar"] {
  direction: rtl;

  .join-community-wrapper {
    direction: ltr;

    .join-community-container {
      direction: rtl;
    }
  }

  @media only screen and (min-width: 768px) {
    .button-blue-rounded button span,
    .button-blue-rounded a span {
        min-width: 125px;
    }
  }

  .app-navigation {
    a {
      &:before {
        left: 0;
        right: 50%;
        transform: translate3d(50%,0,0);
      }
    }

    .join-up-btn-small {
      margin-left: 0;
      margin-right: auto;
    }

    @media only screen and (min-width: 1440px) {
      .join-up-btn-large {
        left: 20px;
        right: auto;
      }
    }

    .hamburger {
      margin-left: 0;
      margin-right: 20px;
    }

    li.gamertag-info img {
      margin-left: 10px;
      margin-right: 0;
    }
  }

  section.features,
  .home-fighters {
    direction: ltr;
  }

  section.features .VueCarousel-slide .feature,
  .home-fighters-carousel .fighter-slide,
  .fighters-grid.home-page {
    direction: rtl;
  }

  @media only screen and (min-width: 768px) {
    .fighter-difficulty strong {
      margin-right: 0;
      margin-left: 25px;
    }
  }

  .title-stylised.title .title-text,
  .latest-news-title.title .title-text {
    text-align: right;
  }

  @media only screen and (min-width: 768px) {
    .title-stylised.title, .latest-news-title.title {
      margin-right: 0;
      margin-left: 5%;
    }
  }

  .news-meta {
    margin-left: 0;
    margin-right: 18px;
  }

  @media only screen and (min-width: 768px) {
    .home-news .news-items-wrapper.news-total-2 .news-item.news-item-1:after {
      left: 0;
      right: -11px;
    }
  }

  @media only screen and (min-width: 768px) {
    .fighter-class-icon {
      margin: 0 0 0 10px;
    }
  }

  .ability-image {
    margin-left: 20px;
    margin-right: 0;
  }

  .mailchimp-signup .input-holder {
    margin-left: 5%;
    margin-right: 0;
  }

  @media only screen and (min-width: 768px) {
    footer ul.legal-links a {
      margin-right: 0;
      margin-left: 15px;
    }
  }

  @media only screen and (min-width: 1440px) {
    .news-view-meta {
      padding-left: 80px;
      padding-right: 0;
    }
  }

  .v--modal-box.v--modal {
    direction: ltr;

    .slide-title,
    .wallpaper-downloads {
      direction: rtl;
    }
  }

  @media only screen and (min-width: 1440px) {
    .latest-news-title {
      text-align: right;
    }
  }
}

html[lang="ru"] {
  .app-navigation {
    .button.join-up-btn a,
    .button.join-up-btn button {
      font-size: 10px;
      font-family: sans-serif;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue